import { render, staticRenderFns } from "./DiscountLabel.vue?vue&type=template&id=691b116b&scoped=true&lang=pug"
import script from "./DiscountLabel.vue?vue&type=script&lang=js"
export * from "./DiscountLabel.vue?vue&type=script&lang=js"
import style0 from "./DiscountLabel.vue?vue&type=style&index=0&id=691b116b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691b116b",
  null
  
)

export default component.exports